import { cn } from "@/lib/utils";

export function SegmentedTabs({ tabs, active, onChange, className }) {
  return (
    <div className={cn("hx-segmented-tabs", className)} role="tablist">
      {tabs.map((tab) => {
        const value = Array.isArray(tab) ? tab[0] : tab.value;
        const label = Array.isArray(tab) ? tab[1] : tab.label;
        const meta = Array.isArray(tab) ? null : tab.meta;
        return (
          <button
            key={value}
            type="button"
            role="tab"
            aria-selected={active === value}
            onClick={() => onChange(value)}
            className={cn("hx-segmented-tab", active === value && "is-active")}
          >
            {label}
            {meta != null && <span>{meta}</span>}
          </button>
        );
      })}
    </div>
  );
}

export function WorkQueueBanner({ title, description, metrics = [] }) {
  return (
    <section className="hx-work-queue">
      <div>
        <p className="hx-eyebrow">Work queue</p>
        <h2>{title}</h2>
        {description && <p>{description}</p>}
      </div>
      {metrics.length > 0 && (
        <div className="hx-work-queue-metrics">
          {metrics.map((metric) => (
            <div key={metric.label}>
              <span>{metric.label}</span>
              <strong>{metric.value}</strong>
            </div>
          ))}
        </div>
      )}
    </section>
  );
}
